<template>
    <div class="o-qr-code-generator qr-code-generator" ref="qr" />
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';
import qrcode from 'qrcode-generator';

export default {
    name: 'OQrCodeGenerator',
    props:{
        useLang: {
            type: Boolean,
            default: false,
        },
        guideMode: {
            type: String,
            default: 'fast',
        }
    },
    computed: {
        ...mapState({
            mapId: state => state.map.id,
            activeLocale: state => state.activeLocale,
            mobileAppBaseUrl: state => state.map.meta.mobile_app_base_url,
        }),
        ...mapGetters([
            'getObject',
            'getTerminalId',
        ]),
        toItemId() {
            return parseInt(this.$route.params.itemId, 10) ||
                parseInt(this.$route.params.id, 10) ||
                parseInt(this.$route.query.mTo, 10);
        },
        isLocalHost(){
            return location.origin.includes('192.168.') ||
                location.origin.includes('localhost') ||
                location.origin.includes('127.0.0.1')
        },
        isProduction(){
            return process.env.VUE_APP_ENVIRONMENT === 'production' || true;
        },
        fromItemId(){
            return this.getTerminalId || this.$route.query.from || this.$route.query.mFrom || '';
        },

        mobileAppUrl(){
            return [
                this.baseUrlWithSlash,
                this.integrationBaseUrlPart,
                this.guideUrlPart || this.catalogUrlPart,
                this.queryUrlPart,
            ].join('');

        },
        baseUrlWithSlash(){
            return _.endsWith(this.baseUrl , '/') ? this.baseUrl : this.baseUrl + '/';
        },
        baseUrl(){
            return this.isProduction ? this.productionMobileUrl : this.developmentLocalUrl
        },

        integrationBaseUrlPart(){
            return `map-${this.mapId}/integrations/web/catalogue/`;
        },
        catalogUrlPart(){
            return 'list';
        },
        guideUrlPart(){
            return this.toItemId && this.fromItemId && 'path';
        },
        queryUrlPart(){
            return [
                this.redirectFromQrCodeQueryPart,
                this.guideModeUrlQueryPart,
                this.langUrlQueryPart,
                this.fromUrlQueryPart,
                this.toUrlQueryPart,
            ].join('');
        },
        redirectFromQrCodeQueryPart(){
            return '?redirect-from=qr';
        },
        toUrlQueryPart(){
            return this.toItemId ? `&mTo=${this.toItemId}` : '';
        },
        guideModeUrlQueryPart(){
            return this.guideMode ? `&mvGuideMode=${this.guideMode}` : '';
        },
        fromUrlQueryPart(){
            return this.fromItemId ? `&mFrom=${this.fromItemId}` : '';
        },
        langUrlQueryPart(){
            return this.useLang ? `&lang=${this.activeLocale}` : '';
        },

        httpsOriginUrl(){
            return location.origin.replace('http://', 'https://');
        },
        productionMobileUrl(){
            return this.mobileAppBaseUrl;
        },
        developmentLocalUrl(){
            return location.origin
        },
    },
    mounted() {
        this.renderQrCode();
    },
    methods: {
        renderQrCode(){
            this.setQrCodeHtml(
                this.generateQrCodeSvgTag(this.mobileAppUrl)
            );
        },
        setQrCodeHtml(html){
            this.$refs.qr.innerHTML = html;
        },
        generateQrCodeSvgTag(url){
            const typeNumber = 0;
            const errorCorrectionLevel = 'L';
            const qr = qrcode(typeNumber, errorCorrectionLevel);

            qr.addData(url);
            qr.make();
            return qr.createSvgTag({ margin: 0});
        },

    }
}
</script>

<style lang="scss" src="./o-qr-code-generator.scss" />
